import clsx from "clsx";
import styles from "./subMenuSpecialItem.module.scss";
import { generatPropsTagA } from "../../../menuItem/generatPropsTagA";
import type { IMenu } from "../../../../../../constants";

interface SubMenuSpecialItemProps {
  item: IMenu;
  onHover?: () => void;
  type?: string;
  activeItems?: number[];
  onBlurItem: () => void;
}

const SubMenuSpecialItem = (props: SubMenuSpecialItemProps) => {
  const { item, onHover, type, activeItems, onBlurItem } = props;
  const propTagA = generatPropsTagA(item, undefined, onBlurItem);
  return (
    <li
      onMouseEnter={onHover}
      id={type + "SubMenuSpecialItem"}
      className={clsx(
        styles["menu-item"],
        type && styles[type],
        activeItems?.includes(item.linkID) && styles["menu-item--active"],
      )}
    >
      {propTagA.href ? (
        <a {...propTagA} className={styles["menu-item--spaces"]}>
          {item.title}
        </a>
      ) : (
        <label className={styles["menu-item--spaces"]}>{item.title}</label>
      )}
    </li>
  );
};

export default SubMenuSpecialItem;
